import {BriefcaseBusiness, GraduationCap, Sparkles, Target} from 'lucide-react';
import {memo, ReactElement} from 'react';
import aboutJson from 'static_configs/about.json';
import {AboutContent, HighlightItem} from 'types';

const content = aboutJson as AboutContent;
const principleIcons = [<Target aria-hidden="true" />, <Sparkles aria-hidden="true" />];

function Principle({item, index}: { item: HighlightItem; index: number }): ReactElement {
  return (
    <article className="principle-card">
      <div className="feature-icon">{principleIcons[index % principleIcons.length]}</div>
      <p className="eyebrow">{item.eyebrow}</p>
      <h3>{item.title}</h3>
      <p>{item.body}</p>
    </article>
  );
}

function AboutSection(): ReactElement {
  return (
    <div className="section-inner about-root">
      <div className="about-copy">
        <p className="eyebrow">{content.eyebrow}</p>
        <h2>{content.title}</h2>
        {content.body.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>

      <div className="about-principles">
        {content.principles.map((item, index) => (
          <Principle key={item.eyebrow} item={item} index={index} />
        ))}
      </div>

      <div className="experience-grid">
        {content.experience.map((item) => (
          <article className="experience-card" key={`${item.period}-${item.title}`}>
            <div className="experience-icon">
              {item.period.toLowerCase().includes('now')
                ? <GraduationCap aria-hidden="true" />
                : <BriefcaseBusiness aria-hidden="true" />}
            </div>
            <p className="eyebrow">{item.period}</p>
            <h3>{item.title}</h3>
            <p className="experience-role">{item.role}</p>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </div>
  );
}

export const About = memo(AboutSection);
